/* import __COLOCATED_TEMPLATE__ from './errorproofing.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();